export default __webpack_public_path__ + "static/ProValue_2@mob-e3e43bafb14d2442ac4e0aee35095525.png";